module.exports = __webpack_public_path__ + "img/listing-active.230f4999.svg";